// extracted by mini-css-extract-plugin
export var quantityInput = "_gg-0";